import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const TeamContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 4px;
`;

export const TeamInformation = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Record = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16m']}
`;

export const GameResultsContainer = styled.div<{ $hasRecord: boolean | undefined }>`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: grid;
    grid-template-columns: ${({ $hasRecord }) => ($hasRecord ? 'repeat(5, 1fr)' : '1fr')};
    flex-wrap: wrap;
`;

export const GameResultContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const Result = styled.div<{ $isWin: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    display: flex;
    width: 100%;
    height: 22px;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: ${({ $isWin, theme }) => ($isWin ? theme.Utility.success : theme.Surface.tertiary)};
    color: ${({ $isWin, theme }) => ($isWin ? theme.Utility.contrast : theme.Text.secondary)};
    border-radius: 2px;
    padding: 4px;
`;

export const NoGamesMessage = styled.div`
    display: flex;
    justify-content: left;
    align-items: center;
    color: ${({ theme }) => theme.Text.secondary};
`;
